import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { addProfile, CamelCaseNamingConvention, createMap, forMember, mapFrom, MappingProfile, namingConventions, typeConverter } from '@automapper/core';
import { Temporal } from '@js-temporal/polyfill';
import { AppModule } from './app/app.module';

import { Intervention } from './app/domain/intervention';

import { Operator } from './app/domain/operator';

import { PointageJournalier } from './app/domain/RH/pointage-journalier';
import { PointagePause } from './app/domain/RH/pointage-pause';
import { SamplingPoint } from './app/domain/sampling-point';

import { User } from './app/domain/user';

import { InterventionDTO } from './app/services/dto/intervention.dto';

import { OperatorDTO } from './app/services/dto/operator.dto';
import { PointageJournalierDTO } from './app/services/dto/pointage-journalier.dto';
import { PointagePauseDTO } from './app/services/dto/pointage-pause.dto';

import { SamplingPointDTO } from './app/services/dto/sampling-point.dto';

import { UserDTO } from './app/services/dto/user.dto';

import { PrelevementAir } from './app/domain/Air/prelevement-air';
import { Consommable } from './app/domain/consommable';
import { Generateur } from './app/domain/Dialyse/generateur';
import { PrelevementGenerateurDialyse } from './app/domain/Dialyse/prelevement-generateur-dialyse';
import { Prelevement } from './app/domain/prelevement';
import { PrelevementSurface } from './app/domain/Surface/prelevement-surface';
import { Zone } from './app/domain/zone';
import { GenerateurDTO } from './app/services/dto/generateur.dto';
import { ConsommableDTO } from './app/services/dto/consommable.dto';
import { PrelevementGenerateurDialyseDTO } from './app/services/dto/prelevement-generateur.dto';
import { PrelevementAirDTO } from './app/services/dto/prelevement-air.dto';
import { PrelevementSurfaceDTO } from './app/services/dto/prelevement-surface.dto';
import { PrelevementDTO } from './app/services/dto/prelevement.dto';
import { ZoneDTO } from './app/services/dto/zone.dto';
import { mapper } from './app/tools/mapping/mapper';
import { environment } from './environments/environment';
import { Flacon } from './app/domain/flacon';
import { FlaconDTO } from './app/services/dto/flacon.dto';
import { VehiculeDTO } from './app/services/dto/vehicule.dto';
import { Vehicule } from './app/domain/RH/vehicule';
import { Endoscope } from './app/domain/Endoscope/endoscope';
import { Canal } from './app/domain/Endoscope/canal';
import { CanalDTO } from './app/services/dto/canal.dto';
import { EndoscopeDTO } from './app/services/dto/endoscope.dto';
import { PrelevementQualifSalleDTO } from './app/services/dto/prelevement-qualif-salle.dto';
import { Appareil } from './app/domain/Qualif/appareil';
import { PrelevementQualifSalle } from './app/domain/Qualif/prelevement-qualif-salle';
import { AppareilDTO } from './app/services/dto/appareil.dto';
import { Soufflage } from './app/domain/Qualif/soufflage';
import { Reprise } from './app/domain/Qualif/reprise';
import { ZoneCompare } from './app/domain/Qualif/zone-compare';
import { SoufflageDTO } from './app/services/dto/soufflage.dto';
import { RepriseDTO } from './app/services/dto/reprise.dto';
import { ZoneCompareDTO } from './app/services/dto/zone-compare.dto';
import { PointagePauseEntity } from './app/db/pointage-pause.entity';
import { UserEntity } from './app/db/user.entity';
import { InterventionEntity } from './app/db/intervention.entity';
import { ZoneEntity } from './app/db/zone.entity';
import { PrelevementAirEntity } from './app/db/prelevement-air.entity';
import { PrelevementSurfaceEntity } from './app/db/prelevement-surface.entity';
import { GenerateurEntity } from './app/db/generateur.entity';
import { PrelevementGenerateurDialyseEntity } from './app/db/prelevement-generateur.entity';
import { EndoscopeEntity } from './app/db/endoscope.entity';
import { CanalEntity } from './app/db/canal.entity';
import { PrelevementQualifSalleEntity } from './app/db/prelevement-qualif-salle.entity';
import { AppareilEntity } from './app/db/appareil.entity';
import { SoufflageEntity } from './app/db/soufflage.entity';
import { RepriseEntity } from './app/db/reprise.entity';
import { ZoneCompareEntity } from './app/db/zone-compare.entity';
import { PrelevementEntity } from './app/db/prelevement.entity';
import { FlaconEntity } from './app/db/flacon.entity';
import { SamplingPointEntity } from './app/db/sampling-point.entity';
import { ConsommableEntity } from './app/db/consommable.entity';
import { LastUsedConsommableEntity } from './app/db/last-used-consommable.entity';
import { OperatorEntity } from './app/db/operator.entity';
import { PointageJournalierEntity } from './app/db/pointage-journalier.entity';

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));

// SELF MAPPING

// DOM -> ENTITY

createMap(mapper, User, UserEntity);
createMap(mapper, Intervention, InterventionEntity,
    typeConverter(Temporal.PlainDate, String, (date) => date.toJSON()));

createMap(mapper, Zone, ZoneEntity,
    typeConverter(Temporal.PlainDateTime, String, (date) => date ? date.toJSON() : undefined));
createMap(mapper, PrelevementAir, PrelevementAirEntity);
createMap(mapper, PrelevementSurface, PrelevementSurfaceEntity);

createMap(mapper, Generateur, GenerateurEntity,
    typeConverter(Temporal.PlainDateTime, String, (date) => date ? date.toJSON() : undefined));
createMap(mapper, PrelevementGenerateurDialyse, PrelevementGenerateurDialyseEntity);

createMap(mapper, Endoscope, EndoscopeEntity,
    typeConverter(Temporal.PlainDateTime, String, (date) => date ? date.toJSON() : undefined));
createMap(mapper, Canal, CanalEntity);

createMap(mapper, PrelevementQualifSalle, PrelevementQualifSalleEntity)
createMap(mapper, Appareil, AppareilEntity);
createMap(mapper, Soufflage, SoufflageEntity);
createMap(mapper, Reprise, RepriseEntity);
createMap(mapper, ZoneCompare, ZoneCompareEntity);

createMap(mapper, Prelevement, PrelevementEntity);
createMap(mapper, SamplingPoint, SamplingPointEntity);
createMap(mapper, Flacon, FlaconEntity);
createMap(mapper, Consommable, ConsommableEntity,
    typeConverter(Temporal.PlainDate, String, (date) => date.toJSON()));
createMap(mapper, Consommable, LastUsedConsommableEntity,
    typeConverter(Temporal.PlainDate, String, (date) => date.toJSON()));

createMap(mapper, Operator, OperatorEntity);

createMap(mapper, PointageJournalier, PointageJournalierEntity,
    typeConverter(Temporal.PlainDateTime, String, (date) => date.toJSON()));
createMap(mapper, PointagePause, PointagePauseEntity,
    typeConverter(Temporal.PlainDateTime, String, (date) => date.toJSON()));

// ENTITY -> DOM 

createMap(mapper, InterventionEntity, Intervention,
    typeConverter(String, Temporal.PlainDate, (date) => date ? Temporal.PlainDate.from(date) : undefined));

createMap(mapper, ZoneEntity, Zone,
    typeConverter(String, Temporal.PlainDateTime, (date) => date ? Temporal.PlainDateTime.from(date) : undefined));
createMap(mapper, PrelevementAirEntity, PrelevementAir,);
createMap(mapper, PrelevementSurfaceEntity, PrelevementSurface);

createMap(mapper, GenerateurEntity, Generateur,
    typeConverter(String, Temporal.PlainDateTime, (date) => date ? Temporal.PlainDateTime.from(date) : undefined));
createMap(mapper, PrelevementGenerateurDialyseEntity, PrelevementGenerateurDialyse);

createMap(mapper, EndoscopeEntity, Endoscope,
    typeConverter(String, Temporal.PlainDateTime, (date) => date ? Temporal.PlainDateTime.from(date) : undefined));
createMap(mapper, CanalEntity, Canal);

createMap(mapper, PrelevementQualifSalleEntity, PrelevementQualifSalle)
createMap(mapper, AppareilEntity, Appareil);
createMap(mapper, SoufflageEntity, Soufflage);
createMap(mapper, RepriseEntity, Reprise);
createMap(mapper, ZoneCompareEntity, ZoneCompare);

createMap(mapper, PrelevementEntity, Prelevement);
createMap(mapper, SamplingPointEntity, SamplingPoint);
createMap(mapper, FlaconEntity, Flacon);
createMap(mapper, ConsommableEntity, Consommable,
    typeConverter(String, Temporal.PlainDate, (date) => date ? Temporal.PlainDate.from(date) : undefined));
createMap(mapper, LastUsedConsommableEntity, Consommable,
    typeConverter(String, Temporal.PlainDate, (date) => {
        if (date) {
            console.log(Temporal.PlainDate.from(date))
            return Temporal.PlainDate.from(date)
        }
        else
            return undefined
    }));

createMap(mapper, UserEntity, User);

createMap(mapper, OperatorEntity, Operator);

// DTO -> DOM
const dtoProfile: MappingProfile = (mapper) => {
    createMap(mapper, InterventionDTO, Intervention,
        typeConverter(String, Temporal.PlainDate, (date) => Temporal.PlainDate.from(date)));
    createMap(mapper, UserDTO, User)

    createMap(mapper, OperatorDTO, Operator)
    createMap(mapper, ZoneDTO, Zone,
        typeConverter(String, Temporal.PlainDateTime, (date) => date ? Temporal.PlainDateTime.from(date) : undefined));

    createMap(mapper, PrelevementAirDTO, PrelevementAir)
    createMap(mapper, PrelevementSurfaceDTO, PrelevementSurface)

    createMap(mapper, PrelevementDTO, Prelevement)
    createMap(mapper, SamplingPointDTO, SamplingPoint)
    createMap(mapper, FlaconDTO, Flacon)
    createMap(mapper, ConsommableDTO, Consommable,
        typeConverter(String, Temporal.PlainDate, (date) => date ? Temporal.PlainDate.from(date) : undefined));

    createMap(mapper, GenerateurDTO, Generateur,
        typeConverter(String, Temporal.PlainDateTime, (date) => date ? Temporal.PlainDateTime.from(date) : undefined));
    createMap(mapper, PrelevementGenerateurDialyseDTO, PrelevementGenerateurDialyse)

    createMap(mapper, PointageJournalierDTO, PointageJournalier,
        typeConverter(String, Temporal.PlainDateTime, (date) => date ? Temporal.PlainDateTime.from(date) : undefined))

    createMap(mapper, PointagePauseDTO, PointagePause,
        typeConverter(String, Temporal.PlainDateTime, (date) => date ? Temporal.PlainDateTime.from(date) : undefined))

    createMap(mapper, VehiculeDTO, Vehicule)

    createMap(mapper, EndoscopeDTO, Endoscope,
        typeConverter(String, Temporal.PlainDateTime, (date) => date ? Temporal.PlainDateTime.from(date) : undefined))
    createMap(mapper, CanalDTO, Canal)

    createMap(mapper, PrelevementQualifSalleDTO, PrelevementQualifSalle, 
        forMember(x => x.Plan, mapFrom(y => y.plan ? `data:image/png;base64,${y.plan}`: '')))
    createMap(mapper, AppareilDTO, Appareil)
    createMap(mapper, SoufflageDTO, Soufflage)
    createMap(mapper, RepriseDTO, Reprise)
    createMap(mapper, ZoneCompareDTO, ZoneCompare)
    // createMap(
    //     mapper,
    //     Bio,
    //     BioDto,
    //     typeConverter(Date, String, (date) => date.toDateString()),
    //     namingConventions(new CamelCaseNamingConvention()) forMember((dest) => dest.PlannedOnTimeSlot, mapFrom(source => source.plannedTimeSlot)
    // );
};
addProfile(
    mapper,
    dtoProfile,
    namingConventions(new CamelCaseNamingConvention())
);

// createMap(mapper, User, UserDto); forMember((d) => d.ZPList, ignore()) , forMember((d) => d.Sampler, ignore()));